import PropTypes from 'prop-types';
import React, { Component } from 'react';
import Modal from 'react-awesome-modal';
import SearchBar from '../SearchBarMP/SearchBarMP';
import PricingAuditRow from './PricingAuditRow';

import './JobAudit.scss';

export default class JobAudit extends Component {
  static propTypes = {
    loading: PropTypes.bool,
    isOpen: PropTypes.bool,
    close: PropTypes.func,
    search: PropTypes.func,
    jobAuditDownload: PropTypes.func,
    auditItems: PropTypes.array,
    job: PropTypes.object
  };

  downloadAudit() {
    const { org_job_id, org_job_title } = this.props.job;
    this.props.jobAuditDownload({
      orgJobId: org_job_id,
      job_title: org_job_title
    });
  }

  getRows(rows, rest) {
    const { loading } = this.props;
    if (Array.isArray(rows)) {
      return rows
        .filter(row => {
          if (row.match === undefined || row.match === true) {
            return true;
          }
          return false;
        })
        .map((row, index) => {
          return <PricingAuditRow row={row} loading={loading} {...rest} key={row.audit_id} />;
        });
    }
  }

  getModal() {
    const { isOpen, close, job, auditItems } = this.props;
    let jobName = job.org_job_title || '';
    let jobCode = job.org_job_code || '';

    const { loading, ...rest } = this.props;
    const rows = this.props.auditItems;
    return (
      <Modal visible={isOpen} onClickAway={close} effect="fadeInDown" height={'550'} width={'900'}>
        <div className="job-audit-modal modal-body">
          <div className="div--modalHeader">
            <h4 className="modal__heading--title">History</h4>
            <span className="icon-cancel pointer pull-right" onClick={close} />
          </div>
          <div className="div__title--decoration" />
          <h3 className="modal__heading--jobTitle">{jobName}</h3>
          <p className="modal__paragraph--headingDetail">
            Job Code
            <span className="span--headingdetail">{jobCode}</span>
          </p>
          <div className="search-download-container">
            {/* don't remove. This may be used very soon
              <button
                className={
                  'btn btn-default btn-sm toolbar__btn--prominent toolbar__btn--genericGridDownload'
                }
                onClick={this.downloadAudit.bind(this)}
                type="submit"
              >
                <i className="icon-down-circled"> </i>
                Download Pricing Audit
              </button>*/}
            <SearchBar
              className="job-audit__search-bar"
              onSearch={event => this.props.search(event, auditItems)}
              placeholder="Search by Date, User or Action"
            />
          </div>
          <div className="div__container--tableModal">
            <table className="table--general table--pricingAudit table">
              <thead className="table__general--header">
                <tr id="table__pricingAudit--header" className="table__general--header">
                  <th className="table__pricingAudit--tableHeading table__tableHeading--date">Date</th>
                  <th className="table__pricingAudit--tableHeading table__tableHeading--user">User</th>
                  <th className="table__pricingAudit--tableHeading">Action</th>
                </tr>
              </thead>
              <tbody>{this.getRows(rows, rest)}</tbody>
            </table>
          </div>
        </div>
      </Modal>
    );
  }

  render() {
    return <div style={{ position: 'relative' }}>{this.props.isOpen ? this.getModal() : null}</div>;
  }
}
